import { clearHyperDXUser, identifyAuthenticatedUser } from "$utils/hyperdx";
import { AppThunk } from "../store";

export const login =
  (email: string, token: string, userInfo: any): AppThunk =>
  (dispatch) => {
    localStorage.setItem(
      "authState",
      JSON.stringify({ user: { email, userInfo }, token })
    );
    identifyAuthenticatedUser({ email, userInfo });
    dispatch({
      type: "LOGIN",
      payload: { user: { email, userInfo }, token },
    });
  };

export const setToken =
  (token: string): AppThunk =>
  (dispatch) => {
    dispatch({
      type: "TOKEN",
      payload: { token },
    });
  };

export const logout = (): AppThunk => (dispatch) => {
  clearHyperDXUser();
  localStorage.removeItem("authState");
  dispatch({
    type: "LOGOUT",
  });
};

export const load = (): AppThunk => (dispatch) => {
  dispatch({
    type: "LOAD",
  });
};

export const loadOut = (): AppThunk => (dispatch) => {
  dispatch({
    type: "LOADOUT",
  });
};

export const userInfo =
  (userInfoUpdate: any): AppThunk =>
  (dispatch, getState) => {
    dispatch({
      type: "USERINFOS",
      payload: { userInfoUpdate },
    });
    const email = getState().auth?.user?.email;
    identifyAuthenticatedUser({ email, userInfo: userInfoUpdate });
  };
